import { faBars, faTableCellsLarge } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { twMerge } from 'tailwind-merge'
import { useStoreContext } from '../../contexts/store.context'
import type { StoreView } from '../../types'

const OPTIONS: Array<[StoreView, string, typeof faBars]> = [
    ['list', 'List view', faBars],
    ['grid', 'Grid view', faTableCellsLarge],
]

/**
 * Grid or list.
 *
 * The same two icons, in the same order, as the Inventory and Kill Race toggles — three pages now
 * offer this choice and a shopper should only have to learn it once. Purely cosmetic: both views
 * render the same items from the same request and open the same checkout.
 */
export const ViewToggle = () => {
    const { view, setView } = useStoreContext()

    return (
        <div className='flex shrink-0 flex-row overflow-hidden rounded border border-white/30'>
            {OPTIONS.map(([value, label, icon]) => (
                <button
                    key={value}
                    onClick={() => setView(value)}
                    aria-pressed={view === value}
                    title={label}
                    aria-label={label}
                    // 44px floor, matching every other control the toolbar grew during the
                    // Inventory pass.
                    className={twMerge(
                        'flex min-h-[2.75rem] w-11 items-center justify-center transition-colors',
                        view === value ? 'bg-white/20 text-white' : 'text-white/50 hover:bg-white/10 hover:text-white/80'
                    )}
                >
                    <FontAwesomeIcon icon={icon} />
                </button>
            ))}
        </div>
    )
}
